/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Log_Entry_3_BodyInputs */

const en_how_we_work_log_entry_3_body = /** @type {(inputs: How_We_Work_Log_Entry_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try it against known scenarios before release.`)
};

const lv_how_we_work_log_entry_3_body = /** @type {(inputs: How_We_Work_Log_Entry_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izmēģinām to zināmos scenārijos pirms ieviešanas.`)
};

/**
* | output |
* | --- |
* | "Try it against known scenarios before release." |
*
* @param {How_We_Work_Log_Entry_3_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_log_entry_3_body = /** @type {((inputs?: How_We_Work_Log_Entry_3_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Log_Entry_3_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_log_entry_3_body(inputs)
	return en_how_we_work_log_entry_3_body(inputs)
});